<template>
  <div class="row help-wrapper">
    <div id="corpo" class="col s12">
      <h6 class="center">Manual de utilização</h6>
      <p>
        Precisa de ajuda para preencher os seus dados? Você está no lugar certo, confira as instruções e o passo-a-passo abaixo explicando detalhadamente o que deve ser preenchido 
        em cada seção e como fazê-lo. As instruções estão disponíveis vídeo-tutoriais.
      </p>
      <ul class="collapsible">
        <li v-bind:class="{'active': active_step === 0}" @click="openStepTutorial(0)">
          <div class="collapsible-header">Download do aplicativo</div>
          <div class="collapsible-body">
            <div v-if="active_step === 0">
              <video width="100%" controls="controls" preload="metadata">
                <source src="https://storage3.onyxerp.com.br/videos-recad-censo/Passo 00 - Tutorial Download.mp4" type="video/mp4">
              </video>
              <template v-if="redirected === true">
                <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s12" id="abouBtnLogin">
                  Voltar
                </router-link>
                <br />
                <br />
              </template>
            </div>
          </div>
        </li>
        <li v-bind:class="{'active': active_step === 1}" @click="openStepTutorial(1)">
          <div class="collapsible-header">Perfil</div>
          <div class="collapsible-body">
            <div v-if="active_step === 1">
              <video width="100%" controls="controls" preload="metadata">
                <source src="https://storage3.onyxerp.com.br/videos-recad-censo/Passo 01 - Perfil.mp4#t=0.5" type="video/mp4">
              </video>
              <template v-if="redirected === true">
                <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s12" id="abouBtnLogin">
                  Voltar
                </router-link>
                <br />
                <br />
              </template>
            </div>
          </div>
        </li>
        <li v-bind:class="{'active': active_step === 2}" @click="openStepTutorial(2)">
          <div class="collapsible-header">Documentos</div>
          <div class="collapsible-body">
            <div v-if="active_step === 2">
              <video width="100%" controls="controls" preload="metadata">
                <source src="https://storage3.onyxerp.com.br/videos-recad-censo/Passo 02 - documentos.mp4#t=0.5" type="video/mp4">
              </video>
              <template v-if="redirected === true">
                <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s12" id="abouBtnLogin">
                  Voltar
                </router-link>
                <br />
                <br />
              </template>
            </div>
          </div>
        </li>
        <li v-bind:class="{'active': active_step === 3}" @click="openStepTutorial(3)">
          <div class="collapsible-header">Contato</div>
          <div class="collapsible-body">
            <div v-if="active_step === 3">
              <video width="100%" controls="controls" preload="metadata">
                <source src="https://storage3.onyxerp.com.br/videos-recad-censo/Passo 03 - contatos.mp4#t=0.5" type="video/mp4">
              </video>
              <template v-if="redirected === true">
                <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s12" id="abouBtnLogin">
                  Voltar
                </router-link>
                <br />
                <br />
              </template>
            </div>
          </div>
        </li>
        <li v-bind:class="{'active': active_step === 4}" @click="openStepTutorial(4)">
          <div class="collapsible-header">Dependentes</div>
          <div class="collapsible-body">
            <div v-if="active_step === 4">
              <video width="100%" controls="controls" preload="metadata">
                <source src="https://storage3.onyxerp.com.br/videos-recad-censo/Passo 04 - dependentes.mp4#t=0.5" type="video/mp4">
              </video>
              <template v-if="redirected === true">
                <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s12" id="abouBtnLogin">
                  Voltar
                </router-link>
                <br />
                <br />
              </template>
            </div>
          </div>
        </li>
        <li v-bind:class="{'active': active_step === 5}" @click="openStepTutorial(5)">
          <div class="collapsible-header">Dados funcionais</div>
          <div class="collapsible-body">
            <div v-if="active_step === 5">
              <video width="100%" controls="controls" preload="metadata">
                <source src="https://storage3.onyxerp.com.br/videos-recad-censo/Passo 05 - Dados Funcionais.mp4#t=0.5" type="video/mp4">
              </video>
              <template v-if="redirected === true">
                <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s12" id="abouBtnLogin">
                  Voltar
                </router-link>
                <br />
                <br />
              </template>
            </div>

          </div>
        </li>
        <li v-bind:class="{'active': active_step === 6}" @click="openStepTutorial(6)">
          <div class="collapsible-header">Avaliação</div>
          <div class="collapsible-body">
            <div v-if="active_step === 6">
              <video width="100%" controls="controls" preload="metadata">
                <source src="https://storage3.onyxerp.com.br/videos-recad-censo/Passo 06 - Avaliação.mp4#t=0.5" type="video/mp4">
              </video>
              <template v-if="redirected === true">
                <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s12" id="abouBtnLogin">
                  Voltar
                </router-link>
                <br />
                <br />
              </template>
            </div>
          </div>
        </li>
        <li v-bind:class="{'active': active_step === 7}" @click="openStepTutorial(7)">
          <div class="collapsible-header">Imagens</div>
          <div class="collapsible-body">
            <div v-if="active_step === 7">
              <video width="100%" controls="controls" preload="metadata">
                <source src="https://storage3.onyxerp.com.br/videos-recad-censo/Passo 07 - Imagens.mp4#t=0.5" type="video/mp4">
              </video>
              <template v-if="redirected === true">
                <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s12" id="abouBtnLogin">
                  Voltar
                </router-link>
                <br />
                <br />
              </template>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tutorial',
  components: {
  },
  data (){
    return {
      active_step: null,
      last_page: this.$store.state.route.from.fullPath,
      redirected: (Number(this.$route.params.step) > 0 ? true : false)
    }
  },
  methods: {
    openStepTutorial(step) {
      setTimeout(() => this.active_step = step, 100)
    },
    initMaterialize() {
      setTimeout(() => M.Collapsible.init((document.querySelectorAll('.collapsible'))), 100)
    }
  },
  mounted(){
    this.active_step = (Number(this.$route.params.step) > 0 ? Number(this.$route.params.step) : 1)
    this.$root.$emit('stopLoadingHeader')
    this.initMaterialize()
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Tutorial.vue